module.exports = __webpack_public_path__ + "img/李湛.1cbc1cf0.png";